import React, { useState } from "react";
import api from '../utils/axiosConfig';

export default function AiTesting() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const res = await api.post(`/nlquery`, { userQuery: query });
        setResults(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <h1 className="text-2xl font-bold mb-4">AI Testing Page</h1>
      <form onSubmit={handleSubmit} className="w-full max-w-md flex gap-2">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Enter your natural language query..."
          className="flex-1 p-2 rounded border"
        />
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Search
        </button>
      </form>

      {loading && <p className="mt-4">Loading...</p>}

      <div className="mt-6 w-full max-w-2xl">
        {results.length > 0 && (
          <table className="min-w-full bg-white border rounded">
            <thead>
              <tr>
                <th className="border px-4 py-2">Code</th>
                <th className="border px-4 py-2">Session</th>
                <th className="border px-4 py-2">Item</th>
                <th className="border px-4 py-2">Response</th>
              </tr>
            </thead>
            <tbody>
              {results.map((row, idx) => (
                <tr key={idx}>
                  <td className="border px-4 py-2">{row.code}</td>
                  <td className="border px-4 py-2">{row.session_id}</td>
                  <td className="border px-4 py-2">{row.item_name}</td>
                  <td className="border px-4 py-2">{row.item_resp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
